<template>
    <div style="width:100%">     
        <el-form-item :label="label">
          <el-select v-model="selectValue" filterable remote  :remote-method="remoteMethod" clearable :loading="loading" @change="() => this.$emit('sync-select-customer', selectValue)" 
             style="display:block;" :placeholder="$t('msg.fuzzyCustomerSearch')" loading-text="loading..." :no-match-text="$t('msg.noDataFound')" :no-data-text="$t('msg.noDataFound')" :disabled="pOnlyView">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

    </div>
</template>

<script>

import { apiFindCust } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {   
    props: {
      pLabel:{
        type:String
      },
      pSelectValue: {
        type: String
      },
      pOnlyView: {
        type: Boolean,
        default: false
      }      
    },
    data() {
      return {
        options: [],
        loading: false,
        selectValue:'',
        label:this.$i18n.t('field.sortl')
      }
    },
    watch:{
      pSelectValue: function(){
        
        if(this.pSelectValue == null || this.pSelectValue ==''){
            this.selectValue = '';
            this.options = [];
        }else{
          this.selectValue = this.pSelectValue;
        }
      } 
    },
    mounted(){
      if(this.pSelectValue != null && this.pSelectValue !=''){
        
        apiFindCust({ headers: authHeader(), condition:this.pSelectValue}).then((response) => { 
          if(response.data != null && response.data.length > 0 ){
            this.selectValue = response.data[0].sortl+'('+this.pSelectValue+')';
          }else{
            this.selectValue = this.pSelectValue;
          }
        }).catch((err) => {
          console.log(err);
        });
      }
      if(this.pLabel != null && this.pLabel != ''){
        this.label = this.pLabel 
      }
    },
    methods: {
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          
          apiFindCust({ headers: authHeader(), condition:query}).then((response) => { 
            this.options = [];
            var temp = [];
            response.data.forEach( function ( item, index, array)  {                              
              temp.push({value:item.sapCode, label: item.sortl+'('+item.sapCode+')' });
            });
            this.options = temp; 
            this.loading = false;
          }).catch((err) => {
            console.log(err);
          });

        } else {
          this.options = [];
        }
      }
    }
}
</script>

<style scoped>
   
</style>